import React from 'react';
import { oneOf, node } from 'prop-types';
import styles from './style.module.scss';

const Alert = ({ children, severity = 'info' }) => (
  <div className={styles[severity]} role="alert">
    <span>{children}</span>
  </div>
);

Alert.propTypes = {
  severity: oneOf(['error', 'info', 'success', 'warning']),
  children: node,
};

export default Alert;
